<template lang="pug">
  v-menu(left)
    template(v-slot:activator='{ on }')
      v-avatar(size='40px' v-on='on')
        img(:src="(user && user.imageUrl) || '/images/'+ user.role+'.png'")
      span {{user.role}}
    v-card
      .pl-1.pt-1
        v-img.imageBox(:src="user.imageUrl || '/images/'+ user.role+'.png'")
          v-card-title.white--text
            .display-1
      v-list.pa-0
        v-list-item(v-for='role in user.roles' :key='role' @click='vibrate();user.role=role')
          v-list-item-avatar
            span.blue--text.headline {{role}}
          v-list-item-title(v-if='role===user.role')
            strong {{roleNames[role]}}
          v-list-item-title(v-else) {{roleNames[role]}}
</template>

<script>
export default {
  name: "role-selector",
  mixins: [],
  props: { user: Object },
  data() {
    return {
      roleNames: {
        GA: "Group Administrator",
        RM: "Restaurant Manager",
        SS: "Section Supervisor",
        SW: "Section Waiter",
        SH: "Section Helper",
        CC: "Counter Chef"
      }
    };
  }
};
</script>
<style  >
.imageBox {
  width: 225px;
  border: 1px solid;
  border-radius: 8px;
}
</style>